/* eslint-disable react-hooks/exhaustive-deps */

import { Grid, TableCell, TableRow } from "@material-ui/core"

import { ModalDeleteConfirm, TableAction } from "App/Component/ui"
import { getComparator, stableSort } from "App/Component/ui/datatable/utils"
import { useDatatables } from "App/hooks"
import {
  defaultToastError,
  formatNumber,
  isNull,
  defaultToastSuccess,
  convertToValidPrice,
} from "App/utils/helpers"
import { FreezeTableClient } from "components/organism"
import React, { useContext, useEffect, useState } from "react"
import {
  DaftarBarang,
  Perhitungan,
  getTotalFilterID,
  getTotal,
  usePembulatanPenjualan,
} from ".."
import { FormContext } from "../../context/FormContext"
import {
  deleteBarangById,
  getBarangByPenjualanID,
  ModalDaftarBarang,
  RESET_STATE_DAFTAR_BARANG,
} from "./DaftarBarang/helpers"

function TabBarang({
  perhitunganPenjualan,
  setPerhitunganPenjualan,

  rowsBarangByKelas,
  loadingBarangByKelas,
  totalDataBarangByKelas,

  formFilterBarangByKelas,
  setFormFilterBarangByKelas,

  setNewDataBarangByKelas,

  handleClickReset,
}) {
  const [rows, setRows] = useState([])
  const [formBarang, setFormBarang] = useState(RESET_STATE_DAFTAR_BARANG)
  const { formData, setFormData } = useContext(FormContext)
  const pembulatan = usePembulatanPenjualan()

  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false)
  const [showModalBarang, setShowModalBarang] = useState(false)

  const getBarangDijual = () => {
    const barang = formData?.barang?.filter(
      (e) =>
        e.id_gudang === formData.gudang_id &&
        e.kelas_id === formData.kelas_id &&
        e.asuransi_id === formData.asuransi_id,
    )

    setRows(barang)
  }

  const deleteBarangDijual = async () => {
    const filterBarang = rows.filter((e) => e.id !== formBarang.id)
    if (!isNull(formData.penjualan_id)) {
      const hargaTotalBarang = await getTotalFilterID(
        rows,
        formBarang.id,
        "barang",
      )

      const totalJasa = getTotal(formData.jasa, "jasa")
      const totalRikjang = getTotal(formData.rikjang, "rikjang")
      const totalFasilitas = getTotal(formData.fasilitas, "fasilitas")
      const totalPaket = getTotal(formData.paket, "paket")

      const jumlah =
        totalJasa +
        totalRikjang +
        hargaTotalBarang +
        totalFasilitas +
        totalPaket

      const potongan = formData.potongan
      const subTotal = jumlah - potongan
      const taxPercent = isNull(formData.tax_percent) ? 0 : formData.tax_percent
      const taxNumber = (taxPercent / 100) * subTotal
      const total = subTotal + taxNumber

      const form = {
        id: formBarang.id,
        penjualanId: formData.penjualan_id,
        harga_total_barang: convertToValidPrice(hargaTotalBarang),
        total_penjualan: convertToValidPrice(jumlah),
        sisa: convertToValidPrice(total),

        tax: taxPercent,
        jumlah_tax: convertToValidPrice(taxNumber),
        discount: convertToValidPrice(formData.potongan / total),
        jumlah_set_discount: potongan,
      }
      const res = await deleteBarangById(form)
      if (res.state) {
        setShowModalDeleteConfirm(false)
        await setNewBarangDijual(filterBarang, false)
        defaultToastSuccess(res.message)
      } else {
        setShowModalDeleteConfirm(false)
        defaultToastError(res.message)
      }
    } else {
      await setNewBarangDijual(filterBarang, false)
      setShowModalDeleteConfirm(false)
      defaultToastSuccess("List barang berhasil dihapus")
    }
  }

  function clickUpdate(row) {
    setShowModalBarang(!showModalBarang)
    if (isNull(formData.penjualan_id)) {
      setFormBarang({
        id: row.id,
        id_barang: row.id_barang,
        id_inventory: row.id_inventory,
        id_gudang: row.id_gudang,
        qty: row.qty,
        keterangan: "",
        harga: row.harga,
        hargapokok: row.hargapokok,
        hargaCustom: row.hargaCustom,
        hargaCustom2: row.hargaCustom2,

        total: row.total,
        namaBarang: row.namaBarang,
        gudang_id: row.gudang_id,
        kelas_id: row.kelas_id,
        asuransi_id: row.asuransi_id,
        diskon: row.diskon,
      })
    } else {
      setFormBarang({
        id: row.id,
        id_barang: row.id_barang,
        id_inventory: row.id_inventory,
        id_gudang: row.id_gudang,
        qty: row.qty,
        keterangan: "",
        harga: row.harga,
        hargapokok: row.hargapokok,
        hargaCustom: row.hargaCustom,
        hargaCustom2: formatNumber(row.hargaCustom),

        total: row.hargaCustom * parseInt(row.qty),
        namaBarang: row.namaBarang,
        gudang_id: formData.gudang_id,
        kelas_id: formData.kelas_id,
        asuransi_id: formData.asuransi_id,
        diskon: row.diskon,
      })
    }
    setShowModalBarang(!showModalBarang)
  }

  function clickDelete(row) {
    setFormBarang({
      ...formBarang,
      id: row?.id,
    })
    setShowModalDeleteConfirm(!showModalDeleteConfirm)
  }

  const handleClickSelect = (row) => {
    if (
      !isNull(formData.asuransi_id) &&
      !isNull(formData.kelas_id) &&
      !isNull(formData.gudang_id)
    ) {
      setFormBarang({
        id: "",
        id_barang: row.barang_id,
        id_inventory: row.id,
        id_gudang: row.gudang_id,
        qty: 1,
        keterangan: "",
        harga: row.hargaJual,
        hargaCustom: row.hargaJual,
        hargapokok: row.hargapokok,
        hargaCustom2: formatNumber(row.hargaJual),
        namaBarang: row.namaBarang,
        gudang_id: formData.gudang_id,
        kelas_id: formData.kelas_id,
        asuransi_id: formData.asuransi_id,
        diskon: formData.diskon?.diskon_barang ?? 0,
        nilai_diskon: 0,
        total_harga_pokok: 0,
        total_harga_jual: 0,
      })
      setShowModalBarang(!showModalBarang)
    } else {
      defaultToastError("Kelas, asuransi dan unit tidak boleh kosong!")
    }
  }

  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: isNull(rows) ? [] : rows,
    orderByDefault: "namaBarang",
    orderByRow: ["namaBarang"],
  })

  const setNewBarangDijual = async (
    barang = formData.barang,
    is_jurnal = formData.is_jurnal,
  ) => {
    const reload = formData.reload_perhitungan || false
    if (isNull(formData.penjualan_id)) {
      setRows(barang)
      setFormData({
        ...formData,
        barang,
        is_jurnal,
        reload_perhitungan: !reload,
      })
    } else {
      const res = await getBarangByPenjualanID(formData.penjualan_id)

      if (res.state) {
        setRows(res.data)
        setFormData({
          ...formData,
          barang: res.data,
          is_jurnal,
          reload_perhitungan: !reload,
        })
      }
    }
  }

  const setNewIfPenjualanIDNotNull = async () => {
    if (!isNull(formData.penjualan_id)) {
      await setNewBarangDijual()
    }
  }

  const setNewBarangByKelasAndGetBarangDijual = async () => {
    await setNewDataBarangByKelas()
    if (isNull(formData.penjualan_id)) {
      getBarangDijual()
    }
  }

  useEffect(() => {
    setNewIfPenjualanIDNotNull()
  }, [
    formData.gudang_id,
    formData.kelas_id,
    formData.asuransi_id,
    formData.penjualan_id,
    formData.reload,
  ])

  useEffect(() => {
    setNewBarangByKelasAndGetBarangDijual()
  }, [
    formData.gudang_id,
    formData.kelas_id,
    formData.asuransi_id,
    formData.penjualan_id,
    formData.reload,
  ])

  useEffect(() => {
    setFormBarang(RESET_STATE_DAFTAR_BARANG)
  }, [formBarang.penjualan_id])

  let total = 0
  return (
    <>
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteBarangDijual()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      {showModalBarang && (
        <ModalDaftarBarang
          setShowModal={() => setShowModalBarang(false)}
          formBarang={formBarang}
          setFormBarang={setFormBarang}
          setNewBarangDijual={setNewBarangDijual}
          handleClickSelect={handleClickSelect}
          totalPenjualan={perhitunganPenjualan.jumlah}
          sisaPenjualan={perhitunganPenjualan.total}
          setNewDataBarangByKelas={setNewDataBarangByKelas}
        />
      )}
      <Grid container spacing={2}>
        <Grid item sm={6}>
          <DaftarBarang
            formBarang={formBarang}
            setFormBarang={setFormBarang}
            rows={rowsBarangByKelas}
            handleClickSelect={handleClickSelect}
            loading={loadingBarangByKelas}
            totalData={totalDataBarangByKelas}
            formFilterBarangByKelas={formFilterBarangByKelas}
            setFormFilterBarangByKelas={setFormFilterBarangByKelas}
            setNewDataBarangByKelas={setNewDataBarangByKelas}
            setNewBarangDijual={setNewBarangDijual}
          />
        </Grid>
        <Grid item sm={6}>
          <Perhitungan
            setNewBarangDijual={setNewBarangDijual}
            perhitunganPenjualan={perhitunganPenjualan}
            setPerhitunganPenjualan={setPerhitunganPenjualan}
            handleClickReset={handleClickReset}
          />
        </Grid>
      </Grid>

      <div className="mt-1">
        <FreezeTableClient
          title="DAFTAR BARANG YANG DIJUAL"
          setQ={setQ}
          withAddButton={false}
          withExportButton={false}
          order={order}
          orderBy={orderBy}
          handleRequestSort={handleRequestSort}
          length={length}
          rows={rows}
          headCells={headCells}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
        >
          {stableSort(data, getComparator(order, orderBy))
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row, index) => {
              const jumlahRaw =
                (pembulatan(row.hargaCustom) - pembulatan(row.nilai_diskon)) *
                row.qty
              const jumlah = pembulatan(jumlahRaw)
              total += jumlah
              return (
                <TableRow hover key={index}>
                  <TableCell
                    scope="row"
                    padding="none"
                    width="5%"
                    align="center"
                  >
                    {index + 1}
                  </TableCell>

                  <TableCell
                    scope="row"
                    padding="none"
                    width="5%"
                    align="center"
                  >
                    {!formData.is_lock && !formData.is_close && (
                      <TableAction
                        clickDelete={() => clickDelete(row)}
                        clickUpdate={() => clickUpdate(row)}
                      />
                    )}
                  </TableCell>
                  <TableCell align="left">{row?.id_barang}</TableCell>
                  <TableCell align="left">{row?.namaBarang}</TableCell>
                  <TableCell align="left" width={"5%"}>
                    {row?.qty}
                  </TableCell>
                  <TableCell align="right" width="10%">
                    {formatNumber(pembulatan(row?.hargaCustom))}
                  </TableCell>
                  <TableCell align="right" width="10%">
                    {formatNumber(row?.diskon)}%
                  </TableCell>
                  <TableCell align="right" width="10%">
                    {formatNumber(pembulatan(row?.nilai_diskon))}
                  </TableCell>
                  <TableCell align="right" width="10%">
                    {formatNumber(jumlah)}
                  </TableCell>
                </TableRow>
              )
            })}

          {rows.length > 0 && (
            <TableRow>
              <TableCell colSpan={headCells.length - 1} align="right">
                TOTAL
              </TableCell>
              <TableCell align="right">
                {formatNumber(pembulatan(total))}
              </TableCell>
            </TableRow>
          )}
        </FreezeTableClient>
      </div>
    </>
  )
}

const MemoizeTabBarang = React.memo(TabBarang)
export default MemoizeTabBarang

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "id_barang",
    disablePadding: false,
    label: "ID BARANG",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "qty",
    disablePadding: false,
    label: "BANYAK",
    align: "left",
  },
  {
    id: "hargaCustom2",
    disablePadding: false,
    label: "HARGA",
    align: "left",
  },
  {
    id: "diskon",
    disablePadding: false,
    label: "DISKON",
    align: "left",
  },
  {
    id: "nilai_diskon",
    disablePadding: false,
    label: "NILAI DISKON",
    align: "left",
  },
  {
    id: "total",
    disablePadding: false,
    label: "JUMLAH",
    align: "left",
  },
]
